module.exports = __webpack_public_path__ + "img/dark-triangle.c2a727bc.svg";